import dev from './dev';
import prod from './prod';

let config = dev;

if (
  process.env.NODE_ENV === 'production' ||
  process.env.VUE_APP_PLATFORM === 'cordova'
) {
  config = prod;
}

export default config;
